module.exports = __webpack_public_path__ + "img/programmer-and-coding-concept.889847ec.jpeg";